import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import type {
  OrderTableSettingsData,
  UseOrderTableSettingsParams,
} from './types';
import {
  getOrderTableSettingsMutationKey,
  getOrderTableSettingsQueryKey,
} from './util';

export const useUpdateOrderTableSettings: MutationFunction<
  OrderTableSettingsData,
  OrderTableSettingsData,
  [UseOrderTableSettingsParams]
> = (params, { requestOptions, queryOptions = {} } = {}) => {
  const queryClient = useQueryClient();

  const { userId } = params;
  const urlPath = `/users/${userId}/order_table_settings`;
  const mutationKey = getOrderTableSettingsMutationKey(params);
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: (requestData) => {
      return request(urlPath, {
        init: {
          method: 'PATCH',
          body: requestData,
        },
      });
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: getOrderTableSettingsQueryKey(params),
      }),
    ...queryOptions,
    mutationKey,
  });
};
